import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import {
  FiCalendar,
  FiClock,
  FiChevronUp,
  FiChevronDown,
} from "react-icons/fi";

export default function EditAttendanceModal({ show, handleClose }) {
  const [showCalendar, setShowCalendar] = useState(false);
  const [showTime, setShowTime] = useState(null);

  const pickerRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowTime(null);
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [date, setDate] = useState("01-05-2026");

  const [time, setTime] = useState({
    checkIn: { h: 9, m: 0, period: "AM" },
    checkOut: { h: 8, m: 47, period: "PM" },
  });

  const formatTime = (t) =>
    `${String(t.h).padStart(2, "0")}:${String(t.m).padStart(
      2,
      "0"
    )} ${t.period}`;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Attendance</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ position: "relative" }}>
        {/* DATE */}
        <Form.Group className="mb-3">
          <Form.Label>Date</Form.Label>

          <div
            onClick={() => setShowCalendar(!showCalendar)}
            style={{ position: "relative", cursor: "pointer" }}
          >
            <Form.Control value={date} readOnly />
            <FiCalendar
              style={{ position: "absolute", right: 10, top: 12 }}
            />
          </div>

          {showCalendar && (
            <div
              ref={pickerRef}
              style={{
                position: "absolute",
                top: 90,
                left: 20,
                background: "#fff",
                padding: 15,
                borderRadius: 10,
                boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                zIndex: 10,
              }}
            >
              <div style={{ textAlign: "center", marginBottom: 10 }}>
                <b>May 2026</b>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(7,1fr)",
                  gap: 6,
                }}
              >
                {[...Array(31)].map((_, i) => (
                  <div
                    key={i}
                    onClick={() => {
                      setDate(`${i + 1}-05-2026`);
                      setShowCalendar(false);
                    }}
                    style={{
                      padding: 6,
                      textAlign: "center",
                      borderRadius: 6,
                      cursor: "pointer",
                      background:
                        i + 1 === 1 ? "#ff6b00" : "transparent",
                      color: i + 1 === 1 ? "#fff" : "#333",
                    }}
                  >
                    {i + 1}
                  </div>
                ))}
              </div>
            </div>
          )}
        </Form.Group>

        <Row>
          {/* CHECK IN */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Check In</Form.Label>
              <div
                onClick={() => setShowTime("checkIn")}
                style={{ position: "relative", cursor: "pointer" }}
              >
                <Form.Control
                  value={formatTime(time.checkIn)}
                  readOnly
                />
                <FiClock
                  style={{ position: "absolute", right: 10, top: 12 }}
                />
              </div>
            </Form.Group>
          </Col>

          {/* CHECK OUT */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Check Out</Form.Label>
              <div
                onClick={() => setShowTime("checkOut")}
                style={{ position: "relative", cursor: "pointer" }}
              >
                <Form.Control
                  value={formatTime(time.checkOut)}
                  readOnly
                />
                <FiClock
                  style={{ position: "absolute", right: 10, top: 12 }}
                />
              </div>
            </Form.Group>
          </Col>
        </Row>

        {/* TIME PICKER */}
        {showTime && (
          <div
            ref={pickerRef}
            style={{
              position: "absolute",
              bottom: 120,
              left: "50%",
              transform: "translateX(-50%)",
              background: "#fff",
              padding: 20,
              borderRadius: 10,
              display: "flex",
              gap: 20,
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              zIndex: 20,
            }}
          >
            {/* HOURS */}
            <div style={{ textAlign: "center" }}>
              <FiChevronUp
                onClick={() =>
                  setTime((prev) => ({
                    ...prev,
                    [showTime]: {
                      ...prev[showTime],
                      h:
                        prev[showTime].h === 12
                          ? 1
                          : prev[showTime].h + 1,
                    },
                  }))
                }
              />
              <div style={{ margin: "10px 0" }}>
                {String(time[showTime].h).padStart(2, "0")}
              </div>
              <FiChevronDown
                onClick={() =>
                  setTime((prev) => ({
                    ...prev,
                    [showTime]: {
                      ...prev[showTime],
                      h:
                        prev[showTime].h === 1
                          ? 12
                          : prev[showTime].h - 1,
                    },
                  }))
                }
              />
            </div>

            {/* MINUTES */}
            <div style={{ textAlign: "center" }}>
              <FiChevronUp
                onClick={() =>
                  setTime((prev) => ({
                    ...prev,
                    [showTime]: {
                      ...prev[showTime],
                      m: (prev[showTime].m + 1) % 60,
                    },
                  }))
                }
              />
              <div style={{ margin: "10px 0" }}>
                {String(time[showTime].m).padStart(2, "0")}
              </div>
              <FiChevronDown
                onClick={() =>
                  setTime((prev) => ({
                    ...prev,
                    [showTime]: {
                      ...prev[showTime],
                      m:
                        prev[showTime].m === 0
                          ? 59
                          : prev[showTime].m - 1,
                    },
                  }))
                }
              />
            </div>

            {/* AM PM */}
            <div
              onClick={() => {
                setTime((prev) => ({
                  ...prev,
                  [showTime]: {
                    ...prev[showTime],
                    period:
                      prev[showTime].period === "AM"
                        ? "PM"
                        : "AM",
                  },
                }));

                setTimeout(() => setShowTime(null), 200);
              }}
              style={{
                background: "#ff6b00",
                color: "#fff",
                padding: "10px",
                borderRadius: 6,
                cursor: "pointer",
                alignSelf: "center",
              }}
            >
              {time[showTime].period}
            </div>
          </div>
        )}

        {/* OTHER FIELDS */}
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Break</Form.Label>
              <Form.Control defaultValue="30 Min" />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Late</Form.Label>
              <Form.Control defaultValue="32 Min" />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mt-3">
          <Form.Label>Production Hours</Form.Label>
          <Form.Control defaultValue="08:55 AM" />
        </Form.Group>

        <Form.Group className="mt-3">
          <Form.Label>Status</Form.Label>
          <Form.Select>
            <option>Present</option>
            <option>Absent</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button style={{ background: "#ff6b00", border: "none" }}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}